import { real_id } from 'src/helpers/interface_helpers';
import { isPeripheralDevice } from 'src/helpers/addons/addon_device_helpers';
import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';
//Types
import type { Device, Devices } from 'src/types/Device';

export const getMainDeviceForLocalActions = (device: Device, allDevices: Devices): Device | undefined =>
	isVirtualDevice(device.type) || isPeripheralDevice(device.type)
		? allDevices[real_id(device.id)]
		: device;
